import "./App.css";
import Weather from "./Weather";

function App() {
  return (
    <div className="App">
      <Weather defaultCity="Sydney" />
      <p>
        This application was coded by Yaroslava Vitkovska and hosted on{" "}
        <a href="https://lucky-capybara-99123d.netlify.app/">Netlify</a>
      </p>
    </div>
  );
}

export default App;
